import { useForm } from "react-hook-form";

import { Typography } from "@braintrust/braintrust-ui-components";
import { ModalConfirm, ModalInstance } from "@js/components/modal";
import { RhfPasswordField } from "@js/rhf/fields/password";

type PasswordConfirmationFormValues = { current_password: string };

type PasswordConfirmationModalContentProps = {
  title: string;
  description: string;
  confirmText: string;
  onConfirm: (password: string) => Promise<void>;
};

const PasswordConfirmationModalContent = ({
  title,
  description,
  confirmText,
  onConfirm,
}: PasswordConfirmationModalContentProps) => {
  const {
    control,
    handleSubmit,
    setError,
    formState: { isSubmitting },
  } = useForm<PasswordConfirmationFormValues>({
    defaultValues: { current_password: "" },
  });

  const onSubmit = async ({
    current_password,
  }: PasswordConfirmationFormValues) => {
    try {
      await onConfirm(current_password);
      ModalInstance.close();
    } catch {
      setError("current_password", { message: "Wrong password." });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Typography
        component="h3"
        variant="title"
        fontWeight={400}
        size="small"
        sx={{ mb: 2 }}
      >
        {title}
      </Typography>
      <Typography component="p" sx={{ mb: 2 }}>
        {description}
      </Typography>
      <RhfPasswordField
        control={control}
        name="current_password"
        id="current_password"
        label="Current password"
        color="secondary"
        variant="outlined"
        rules={{ required: "This field is required" }}
      />
      <ModalConfirm
        onCancel={ModalInstance.close}
        onConfirm="submit"
        confirmDisabled={isSubmitting}
        confirmText={confirmText}
      />
    </form>
  );
};

export const openPasswordConfirmationModal = (
  props: PasswordConfirmationModalContentProps,
) => {
  ModalInstance.open({
    closeButton: false,
    children: <PasswordConfirmationModalContent {...props} />,
  });
};
